import { Link } from 'react-router-dom';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import BordPhoto from '../../../../../../components/NudosComponents/BordPhoto/BordPhoto';
import { TcountryCode } from '../../../../../../components/NudosComponents/BordFlag/BordFlag.types';
import BordOneToneIcon from '../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './LogisticServiceOrganizationInformation.scss';

const LogisticServiceOrganizationInformation = ({
  logisticServiceData
}: {
  logisticServiceData: IlogisticServiceDetails;
}) => {

  const { organization, id: logisticServiceId } = logisticServiceData;
  const { organizationId, organizationName, country, imageUrl, levelSubscription } = organization || {};
  const standardClient = levelSubscription === 'Free';
  const noDataText = 'Sin datos';
  const renderTypeOfClientText = standardClient ? 'Cliente Standard' : 'Cliente Platinum';
  const seeOrganizationRedirectionData = {
    pathname: `/organization/details/${organizationId}`,
    state: {
      originUrl: `/logistic-service/details/${logisticServiceId}`
    }
  };

  return (
    <div className="LogisticServiceOrganizationInformation">
      <div className="LeftOrganizationInformation">
        <div className="titlesSection">
          <div className="logisticServiceDetailsTab1SectionTitle">Información de la empresa</div>
        </div>
        <div className="organizationDataSection">
          <BordPhoto
            variant="circle"
            size="s40"
            style={{
              border: '1px solid #B4B4B4'
            }}
            flagProps={{
              variant: 'circle',
              customWidth: '14px',
              country: country?.code as TcountryCode
            }}
            imageProps={{
              style: {
                borderRadius: '100%',
                width: '40px',
                height: '40px'
              }
            }}
            oneToneIconProps={{
              variant: 'building3',
              standardSize: 14
            }}
            url={imageUrl ?? undefined}
          />
          <div>
            <div className="flex items-center gap-1">
              <div className="font-bold organizationName">{organizationName ?? noDataText}</div>
              <Link className="seeOrganization" to={seeOrganizationRedirectionData}>
                <div className="iconStyle">
                  <BordOneToneIcon
                    variant="externalLink"
                    customWidth="10px"
                    style={{
                      stroke: '#54A1FC'
                    }}
                  />
                </div>
              </Link>
            </div>
            <div className="text-xs">{renderTypeOfClientText}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogisticServiceOrganizationInformation;
